<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body text-center mb-8">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0"
          v-text="'Edit Membership Group'"
        />
      </header>
      <div class="text-left">
        <label
          for="title"
          v-text="'Group Title'"
        />
        <input
          id="title"
          v-model="title"
          type="text"
          name="title"
          class="input"
          placeholder="Title"
        >
        <label
          for="description"
          v-text="'Group Description'"
        />
        <textarea
          id="description"
          v-model="description"
          name="description"
          cols="30"
          placeholder="Description"
          rows="10"
        />
        <label
          for="membershipGroupTypes"
          v-text="'Group Types'"
        />
        <div class="select-container">
          <select v-model="type_id">
            <option
              v-for="membershipGroupType in membershipGroupTypes"
              :key="membershipGroupType.id"
              :value="membershipGroupType.id"
              v-text="membershipGroupType.title"
            />
          </select>
        </div>
        <input
          id="selfAssignable"
          v-model="self_assignable"
          type="checkbox"
          name="selfAssignable"
        >
        <label
          for="selfAssignable"
          v-text="'Self assignable group'"
        />
        <input
          id="listInsideCalendarEvents"
          v-model="list_inside_calendar_events"
          type="checkbox"
          :disabled="disableListInsideCalendarEvents"
          :aria-disabled="disableListInsideCalendarEvents"
          name="listInsideCalendarEvents"
        >
        <label
          for="listInsideCalendarEvents"
          :class="{ 'text-grey-dark': disableListInsideCalendarEvents }"
          v-text="'List inside calendar events'"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="btn"
        type="button"
        @click.prevent="save"
        v-text="'Save'"
      />
      <button
        class="mx-4 px-2 text-blue underline"
        type="button"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'EditMembershipGroupDetailsModal',
  props: {
    groupsListedInsideCalendar: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      title: '',
      description: '',
      type_id: '',
      self_assignable: null,
      list_inside_calendar_events: false,
    }
  },
  computed: {
    membershipGroupTypes() {
      return this.$store.state.membership.membershipGroupTypes
    },
    membershipGroup() {
      return this.$store.state.membership.editMembershipGroupModal.membershipGroup
    },
    show() {
      return this.$store.state.membership.editMembershipGroupModal.open
    },
    disableListInsideCalendarEvents() {
      if (
        this.membershipGroup &&
        this.groupsListedInsideCalendar.length >= 1 &&
        this.groupsListedInsideCalendar.map(group => group.uuid).includes(this.membershipGroup.uuid)
      ) {
        return false
      }

      return this.groupsListedInsideCalendar.length >=2
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.title = this.membershipGroup.attributes.title
        this.description = this.membershipGroup.attributes.description
        this.type_id = this.membershipGroup.attributes.type_id
        this.self_assignable = this.membershipGroup.attributes.self_assignable
        this.list_inside_calendar_events = this.membershipGroup.attributes.list_inside_calendar_events
      }

      if (this.show && !this.membershipGroupTypes.length) {
        this.$store.dispatch('membershipGetMembershipGroupTypes')
          .then(() => {
            this.presetType()
          })
      }
    },
  },
  methods: {
    save() {
      this.$api.active().put(`memberships/membership-groups/${this.membershipGroup.attributes.uuid}`, {
        title: this.title,
        description: this.description,
        type_id: this.type_id,
        self_assignable: this.self_assignable,
        list_inside_calendar_events: this.list_inside_calendar_events,
      }).then(() => {
        this.$emit('membershipGroupHasBeenUpdated')

        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: 'Membership group updated!',
        })

        this.close()
      })
    },
    presetType() {
      if (this.type_id) {
        return
      }

      this.type_id = this.membershipGroupTypes[0].id
    },
    close() {
      this.$store.commit('membershipCloseEditMembershipGroupModal')
    },
  },
}
</script>
